import type { UserListItem } from "@/models/user.model";
import { SubjectDtoType } from "@/spz-api/model";
import { IconButton } from "@spz/ui/components/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@spz/ui/components/tooltip";
import type { Row } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { selectAccessControlViewModel } from "../../view-models/select-access-control-view-model";

export const ActionsCell = ({ row }: { row: Row<UserListItem> }) => {
  const { t } = useTranslation();
  const { openAccessControlSheet } = selectAccessControlViewModel({});
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton
          icon="key"
          variant="ghost"
          onClick={() => {
            openAccessControlSheet({
              subjectName: `${row.original.firstName} ${row.original.lastName}`,
              subjectId: row.original.id.toString(),
              subjectType: SubjectDtoType.USER,
            });
          }}
          ghostInTableCell
        />
      </TooltipTrigger>
      <TooltipContent>{t("access_controls")}</TooltipContent>
    </Tooltip>
  );
};
